module.exports = __webpack_public_path__ + "img/ring_r_s_null_1@3x.f8bc0e1b.png";